import React from 'react';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../reduxStore/redux-hooks';

const UseScrollHandler = (responseBoxRef: React.RefObject<HTMLDivElement>, dynamicContent: React.ReactNode) => {
  const dispatch = useAppDispatch();
  const [showScrollButton, setShowScrollButton] = useState(false);
  const clearValue = useAppSelector((state) => state.history.historyState.clearValue);

  const currentResponseBoxRef = responseBoxRef.current;
  useEffect(() => {
    if (clearValue && currentResponseBoxRef) {
      scrollToBottom(currentResponseBoxRef);
    }
  }, [clearValue, dispatch]);

  useEffect(() => {
    if (currentResponseBoxRef) {
      const isScrollable = currentResponseBoxRef.scrollHeight > currentResponseBoxRef.clientHeight;
      setShowScrollButton(isScrollable);
    }
  }, [dynamicContent, responseBoxRef]);

  useEffect(() => {
    const element = responseBoxRef.current;
    if (!element) return;
    const handleScroll = (): void => {
      const isAtBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - 1;
      setShowScrollButton(!isAtBottom);
    };
    element.addEventListener('scroll', handleScroll);
    return () => element.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToBottom = (element: HTMLElement) => {
    element.scrollTo({
      top: element.scrollHeight,
      behavior: 'smooth',
    });
  };

  const handleScrollToBottom = () => {
    if (currentResponseBoxRef) {
      scrollToBottom(currentResponseBoxRef);
      setTimeout(() => setShowScrollButton(false), 300); // Ensure button hides after smooth scroll
    }
  };

  return { showScrollButton, handleScrollToBottom };
};

export default UseScrollHandler;
